import httpClient from '../../api/client';

export default async () => {
  const response = await httpClient.get('/issuers');

  return response;
};
